// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a1758b2","795":"c6f806dc"}[chunkId] + ".chunk.js";
};